/**
 * Feature Flags — Dashboard Shell
 *
 * Central feature flag registry for all domain shell apps.
 * Flags can be overridden at runtime via URL params or environment variables.
 *
 * @package @plerity/dashboard-shell
 */

/**
 * Dev Notes feature flag.
 *
 * Activation priority (first match wins):
 * 1. `?nodevnotes=true` URL param → disabled
 * 2. `?devnotes=true` URL param → enabled
 * 3. `VITE_DEV_NOTES_ENABLED=true` env var → enabled
 * 4. Default → disabled
 *
 * In development, set `VITE_DEV_NOTES_ENABLED=true` in `.env.development`.
 * In production, activate per-session with `?devnotes=true` in the URL.
 */
export function isDevNotesEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get("nodevnotes") === "true") return false;
  if (params.get("devnotes") === "true") return true;
  return import.meta.env.VITE_DEV_NOTES_ENABLED === "true";
}

/**
 * Central feature flags object.
 * Add new flags here as the system grows.
 */
export const featureFlags = {
  devNotes: isDevNotesEnabled,
} as const;
